import $ from "jquery";

window.$ = $;

var scope;
var compile;

function initDirectiveService(angularScope, angularCompile) {
	scope = angularScope;
	compile = angularCompile;
}

function addDirectiveForView(view, beta) {
	var id = dashboardViewMap[view];
	
	if(id != undefined) {
		addDirective(id, beta);
	}
}

function replaceDirective(id, oldDirectiveName, newDirectiveName) {
	if(scope == undefined) {
		console.error("You must initialize directive service before trying to add a directive!");
	}
	
	try
	{	
		// grab the element that needs a directive added to it
		var element = $('#' + id);
	
		// add and compile the directive
		if(element != undefined) {
			
			if(oldDirectiveName != undefined) {
				// remove the old directive
				element.removeAttr(oldDirectiveName);
			}
			
			element.attr(newDirectiveName, "1");
			compile(element)(scope);
			
			console.log("Injected directive [" + newDirectiveName + "] into div: " + id);
		}
	} catch (error)
	{
		console.error("Failed to inject directive [" + newDirectiveName + "] into div: " + id, error);
	}
}

function addDirective(id, beta) {
	if(scope == undefined) {
		console.error("You must initialize directive service before trying to add a directive!");
	}
	
	try
	{
		if(hasLoadedDirective(id)) {
			// directive already added or doesn't exist
			return;
		}
		
		// get the directive name
		var directiveName = getDirective(id, beta);
		
		// grab the element that needs a directive added to it
		var element = $('#' + id);
	
		// add and compile the directive
		if(element != undefined) {
			element.attr(directiveName, "1");
			compile(element)(scope);
			
			console.log("Injected directive [" + directiveName + "] into div: " + id);
		}
	} catch (error)
	{
		console.error("Failed to inject directive [" + directiveName + "] into div: " + id, error);
	}
	
}

function getDirective(id, beta) {
	loadedDirectives[id] = true;
	
	if(beta && directiveBetaMap[id] != undefined) {
		return directiveBetaMap[id];
	}
	
	return directiveMap[id];
}

function hasLoadedDirective(id) {
	return loadedDirectives[id] || (directiveMap[id] == undefined);
}

var directiveBetaMap = {
		
}

var directiveMap = {
		analytics_report: 'analytics-report-directive',

		dashboard_content_library : 'dashboard-content-library-directive',
		dashboard_content_approvals : 'dashboard-content-approvals-directive',
		dashboard_content_info : 'dashboard-content-info-directive',
		dashboard_content_recommendations : 'dashboard-content-recommendations-directive',
		dashboard_content_auto_import : 'dashboard-content-auto-import-directive',
		dashboard_broadcast : 'dashboard-broadcast-directive',
		dashboard_mobile_broadcast : 'dashboard-mobile-broadcast-directive',
		create_schedule_parent : 'create-schedule-parent-directive',
		create_trigger_parent : 'create-trigger-parent-directive',
		dashboard_highlevel : 'dashboard-highlevel-router',
		dashboard_mobile_highlevel : 'dashboard-mobile-highlevel-directive',
		dashboard_mobile_upcoming : 'dashboard-mobile-upcoming-directive',
		dashboard_mobile_social_inbox : 'dashboard-mobile-social-inbox-directive',
		dashboard_calendar : 'upcoming-posts-router',
		dashboard_account : 'dashboard-account-directive',
		dashboard_brand_settings : 'dashboard-brand-settings-router',
		dashboard_billing : 'dashboard-billing-directive',
		dashboard_developer_settings : 'dashboard-developer-settings-directive',
		dashboard_analytics : 'dashboard-analytics-directive',
		dashboard_account_analytics : 'dashboard-account-analytics-directive',
		dashboard_hashtag_analytics : 'dashboard-hashtag-analytics-directive',
		dashboard_category_analytics : 'dashboard-category-analytics-directive',
		dashboard_ad_analytics : 'dashboard-ad-analytics-directive',
		dashboard_ad_analytics_objective : 'dashboard-ad-analytics-objective-directive',
		dashboard_ad_analytics_campaign : 'dashboard-ad-analytics-campaign-directive',
		dashboard_analytics_post_type : 'dashboard-analytics-post-type-directive',
		dashboard_analytics_community : 'dashboard-analytics-community-directive',
		dashboard_analytics_reports : 'dashboard-analytics-reports-directive',
		dashboard_post_info : 'dashboard-post-info-router', 
		dashboard_mobile_post_info : 'dashboard-mobile-post-info-directive', 
		dashboard_activity : 'dashboard-activity-directive',
		dashboard_social_inbox : 'dashboard-social-inbox-router',
		dashboard_schedules : 'dashboard-schedules-directive',
		dashboard_triggers : 'dashboard-triggers-directive',
		dashboard_triggers_pending_transfer : 'dashboard-triggers-pending-transfer-directive',
		dashboard_trigger_suggestions : 'dashboard-trigger-suggestions-directive',
		dashboard_website_growth_hacks : 'dashboard-growthhack-website-performance-directive',
		create_evergreen_content_directive : 'create-evergreen-content-directive',
		add_content_directive : 'add-content-directive',
		add_images_directive : 'add-images-directive',
		dashboard_mobile_add_images_directive : 'dashboard-mobile-add-images-directive',
		dashboard_mobile_add_video_directive : 'dashboard-mobile-add-video-directive',
		schedule_content_modal : 'schedule-content-directive',
		dashboard_mobile_schedule_broadcast_modal : 'dashboard-mobile-schedule-broadcast-directive',
		schedule_broadcast_modal : 'schedule-broadcast-directive',
		create_auto_import_source_directive : 'create-auto-import-source-directive',
		dashboard_mobile_choose_content_tag_modal_directive : 'dashboard-mobile-choose-content-tag-modal-directive',
		choose_content_tag_modal_directive : 'choose-content-tag-modal-directive',
		edit_content_tag_modal_directive : 'edit-content-tag-modal-directive',
		choose_content_tag_ai_modal_directive : 'choose-content-tag-ai-modal-directive',
		dashboard_mobile_manage_hashtags_modal_directive : 'dashboard-mobile-manage-hashtags-modal-directive',
		manage_hashtags_modal_directive : 'manage-hashtags-modal-directive',
		manage_canned_response_modal_directive : 'manage-canned-response-modal-directive',
		dashboard_mobile_manage_canned_response_modal_directive : 'dashboard-mobile-manage-canned-response-modal-directive',
		trigger_auto_fill_modal_directive : 'trigger-auto-fill-modal-directive',
		upload_media_modal_directive : 'upload-media-modal-directive',
		upload_content_csv_modal_directive : 'upload-content-csv-modal-directive',
		edit_roi_data_modal_directive : 'edit-roi-data-modal-directive',
		dashboard_mobile_upcoming_post_modal_directive : 'dashboard-mobile-upcoming-post-modal-directive',
		upcoming_post_modal_directive : 'upcoming-post-modal-directive',
		add_brand_modal_directive : 'add-brand-modal-directive',
		add_user_modal_directive : 'add-user-modal-directive',
		edit_user_modal_directive : 'edit-user-modal-directive',
		import_existing_content_modal_directive : 'import-existing-posts-modal-directive',
		create_content_approval_modal_directive : 'create-content-approval-modal-directive',
		create_invite_link_modal_directive : 'create-invite-link-modal-directive',
		bulk_manage_content_modal_directive : 'bulk-manage-content-modal-directive',
		dashboard_mobile_add_link_directive : 'dashboard-mobile-add-link-directive',
		create_schedule_modal_directive : 'create-schedule-modal-directive',
		authorize_groups_modal_directive : 'authorize-groups-modal-directive',
		billing_disclaimer_modal_directive : 'billing-disclaimer-modal-directive',
		add_to_queue_modal_directive : 'add-to-queue-modal-directive',
		dashboard_mobile_assign_message_modal_directive : 'dashboard-mobile-assign-message-modal-directive',
		assign_message_modal_directive : 'assign-message-modal-router',
		reorder_queue_modal_directive : 'reorder-queue-modal-directive',
		select_integration_modal_directive : 'select-integration-modal-directive',
		dashboard_demo_gate : 'dashboard-demo-gate-directive',
		edit_trigger_modal : 'edit-trigger-directive',
		edit_weather_trigger_modal : 'edit-weather-trigger-directive',
		edit_web_trigger_modal : 'edit-web-trigger-directive',
		edit_weekly_trigger_modal : 'edit-weekly-trigger-directive',
		upgrade_triggers_modal : 'upgrade-triggers-modal-directive',
		upgrade_cre_modal : 'upgrade-cre-modal-directive',
		upgrade_analytics_modal : 'upgrade-analytics-modal-directive',
		upgrade_account_modal : 'upgrade-account-modal-directive',
		delete_confirmation_modal: 'delete-confirmation-modal-directive',
		password_check_modal: 'password-check-modal-directive',
		upgrade_accounts_modal : 'upgrade-accounts-modal-directive',
		upgrade_content_modal : 'upgrade-content-modal-directive',
		post_content_modal : 'post-content-directive',
		trial_account_expired_modal : 'account-expired-modal-directive',
		authorize_platform_modal : 'authorize-platform-directive',
		authorize_platform_to_post_modal : 'authorize-platform-to-post-directive',
		backdate_post_modal : 'backdate-post-modal-directive',
		post_backdated_content_modal : 'post-backdated-content-modal-directive',
		select_default_sub_accounts_modal_directive : 'select-default-sub-accounts-modal-directive',
		select_post_sub_accounts_modal_directive : 'select-post-sub-accounts-modal-directive',
		dashboard_mobile_select_post_sub_accounts_modal_directive : 'dashboard-mobile-select-post-sub-accounts-modal-directive',
		ambassador_modal_directive : 'ambassador-modal-directive', 
		admin_wl_settings_modal : 'admin-wl-settings-modal',
		mobile_filter_social_inbox_modal: 'mobile-filter-social-inbox-modal-directive',
		c2_view: 'c2-view-directive'
}

var dashboardViewMap = {
		LIBRARY : 'dashboard_content_library',
		APPROVALS : 'dashboard_content_approvals', 
		CONTENT_INFO : 'dashboard_content_info',
		CONTENT_RECOMMENDATIONS : 'dashboard_content_recommendations',
		CONTENT_AUTO_IMPORT : 'dashboard_content_auto_import',
		BROADCAST : 'dashboard_broadcast',
		MOBILE_BROADCAST : 'dashboard_mobile_broadcast',
		CREATE_SCHEDULE : 'create_schedule_parent',
		CREATE : 'create_trigger_parent',
		DASHBOARD : 'dashboard_highlevel',
		HOME : 'dashboard_highlevel',
		UPCOMING : 'dashboard_calendar',
		ACCOUNT : 'dashboard_account',
		BRAND_SETTINGS : 'dashboard_brand_settings',
		BILLING : 'dashboard_billing',
		DEVELOPER : 'dashboard_developer_settings',
		ANALYTICS : 'dashboard_analytics',
		HASHTAG_ANALYTICS : 'dashboard_hashtag_analytics',
		CATEGORY_ANALYTICS : 'dashboard_category_analytics',
		ACCOUNT_ANALYTICS : 'dashboard_account_analytics',
		AD_ANALYTICS : 'dashboard_ad_analytics',
		AD_ANALYTICS_OBJECTIVE : 'dashboard_ad_analytics_objective',
		AD_ANALYTICS_CAMPAIGN : 'dashboard_ad_analytics_campaign',
		ANALYTICS_POST_TYPE : 'dashboard_analytics_post_type',
		ANALYTICS_COMMUNITY : 'dashboard_analytics_community',
		ANALYTICS_REPORTS  : 'dashboard_analytics_reports',
		POST_INFO : 'dashboard_post_info',
		MOBILE_POST_INFO : 'dashboard_mobile_post_info',
		ACTIVITY : 'dashboard_activity',
		MENTIONS : 'dashboard_activity',
		LISTENING : 'dashboard_activity',
		DIRECT_MESSAGES : 'dashboard_activity',
		INBOX : 'dashboard_social_inbox',
		SCHEDULES : 'dashboard_schedules',
		TRIGGERS_PENDING_TRANSFER : 'dashboard_triggers_pending_transfer',
		SUGGESTIONS : 'dashboard_trigger_suggestions',
		WEBSITE_GROWTHHACK : 'dashboard_website_growth_hacks',
		MOBILE : 'dashboard_mobile_highlevel',
		MOBILE_UPCOMING : 'dashboard_mobile_upcoming',
		MOBILE_INBOX : 'dashboard_mobile_social_inbox',
		C2_VIEW: 'c2_view'
}

var loadedDirectives = {};

export { addDirective, replaceDirective, addDirectiveForView, initDirectiveService }
